import React from 'react';
import { RetryErrorComponent } from '@/components/RetryErrorComponent';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { useErrorNavigation } from '@/hooks/useErrorNavigation';

export function RunTimeModalError({ isOpen, close = () => {} }) {
  const { t } = useTranslation();
  const { reloadSearch, redirectHome } = useErrorNavigation();

  return (
    <RetryErrorComponent
      open={isOpen}
      title={t('pricefreeze.error.search.header')}
      text={t('pricefreeze.error.search.body')}
      retryText={t('pricefreeze.error.search.buttonReTry')}
      reviewText={t('pricefreeze.error.search.buttonReview')}
      onClose={close}
      onRetry={reloadSearch}
      onReview={redirectHome}
    />
  );
}
